import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./STDTD.styles";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import STDTDFiltersAndReports from "./STDTDFiltersAndReports.component";
import { ApprovalProvider } from "../../../context/ApprovalContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const STDTD = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        <HedgeRatioProvider>
          <ApprovalProvider>
            <STDTDFiltersAndReports />
          </ApprovalProvider>
        </HedgeRatioProvider>

        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default STDTD;
